import { DataService } from "./data.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Url } from "../common/url";
@Injectable({
  providedIn: "root",
})
export class EngineService extends DataService {
  constructor(http: HttpClient, private localHttp: HttpClient) {
    super("engine", http);
  }

  url: string = Url.engine;

  getAll() {
    return this.localHttp.get(this.url + "?filter[include]=powertrain");
  }

  getEnginesWithLastOrderAndLastVisitByFromandToMaintenanceValues(
    from?: number,
    to?: number
  ) {
    return this.localHttp.get(
      this.url + "/get/engine/data/hours?from=" + from + "&to=" + to
    );
  }

  getEngineDifferenceForAPowerCoach(from: number = null, to: number = null) {
    return this.localHttp.get(
      this.url + "/powercoach/motor/difference?from=" + from + "&to=" + to
    );
  }

  getWantedPowerCoach() {
    return this.localHttp.get(this.url + "/wanted/powercoach");
  }
}
